export default __webpack_public_path__ + "static/background-image-80cfb603ba71373aef4d1d879f2bf7e1.png";